// extracted by mini-css-extract-plugin
export default {"wrapper":"_fbe7ecd4"};